module.exports = __webpack_public_path__ + "img/bg.e3e19305.svg";